import { render, staticRenderFns } from "./register-form-auth-link.vue?vue&type=template&id=946c5240&"
var script = {}
import style0 from "./register-form-auth-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports